import { collection, addDoc, updateDoc, deleteDoc, doc, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";

// Funciones genéricas CRUD
const getCollection = async (collectionName) => {
  try {
    const querySnapshot = await getDocs(collection(db, collectionName));
    return querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error(`Error getting ${collectionName}:`, error);
    throw error;
  }
};

const addDocument = async (collectionName, data) => {
  try {
    const docRef = await addDoc(collection(db, collectionName), data);
    return { id: docRef.id, ...data };
  } catch (error) {
    console.error(`Error adding to ${collectionName}:`, error);
    throw error;
  }
};

const updateDocument = async (collectionName, id, data) => {
  try {
    const docRef = doc(db, collectionName, id);
    await updateDoc(docRef, data);
    return { id, ...data };
  } catch (error) {
    console.error(`Error updating ${collectionName}:`, error);
    throw error;
  }
};

const deleteDocument = async (collectionName, id) => {
  try {
    const docRef = doc(db, collectionName, id);
    await deleteDoc(docRef);
    return id;
  } catch (error) {
    console.error(`Error deleting from ${collectionName}:`, error);
    throw error;
  }
};

// Funciones para Clientes
export const getClients = () => getCollection("clients");
export const addClient = (clientData) => addDocument("clients", clientData);
export const updateClient = (id, clientData) => updateDocument("clients", id, clientData);
export const deleteClient = (id) => deleteDocument("clients", id);

// Funciones para Proyectos
export const getProjects = () => getCollection("projects");
export const addProject = (projectData) => addDocument("projects", projectData);
export const updateProject = (id, projectData) => updateDocument("projects", id, projectData);
export const deleteProject = (id) => deleteDocument("projects", id);

// Funciones para Conceptos
export const getConcepts = () => getCollection("concepts");
export const addConcept = (conceptData) => addDocument("concepts", conceptData);
export const updateConcept = (id, conceptData) => updateDocument("concepts", id, conceptData);
export const deleteConcept = (id) => deleteDocument("concepts", id);

// Funciones para Cargos
export const getCharges = () => getCollection("charges");
export const addCharge = (chargeData) => addDocument("charges", chargeData);
export const updateCharge = (id, chargeData) => updateDocument("charges", id, chargeData);
export const deleteCharge = (id) => deleteDocument("charges", id);

export const getFutureCharges = async (proyectoId, conceptoId, fechaBase) => {
  try {
    console.log("Buscando cobros futuros con:", {
      proyectoId,
      conceptoId,
      fechaBase
    });

    const chargesRef = collection(db, "charges");
    const fechaBaseISO = fechaBase instanceof Date 
      ? fechaBase.toISOString() 
      : new Date(fechaBase).toISOString();
    
    console.log("Fecha base ISO:", fechaBaseISO);

    const q = query(
      chargesRef,
      where("proyecto_id", "==", proyectoId),
      where("concepto_id", "==", conceptoId),
      where("fecha_vencimiento", ">=", fechaBaseISO)
    );
    
    const querySnapshot = await getDocs(q);
    const charges = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // Ordenar los cobros: primero los pendientes, luego por fecha
    const sortedCharges = charges.sort((a, b) => {
      // Si ambos son pendientes o ambos son pagados, ordenar por fecha
      if (a.estado === b.estado) {
        return new Date(a.fecha_vencimiento) - new Date(b.fecha_vencimiento);
      }
      // Si uno es pendiente y otro no, el pendiente va primero
      return a.estado === "Pendiente" ? -1 : 1;
    });

    console.log("Cobros futuros encontrados y ordenados:", sortedCharges);
    return sortedCharges;
  } catch (error) {
    console.error("Error al obtener cobros futuros:", error);
    throw error;
  }
};
